import { useProductsFilters } from "lib/products"
import { useTranslation } from "lib/i18n/translation"
import Loader from "lib/loader"

export default ({
	loaderColor
}) => {

	const { c } = useTranslation("common")
	const { loading } = useProductsFilters()

	if(!loading){
		return null
	}

	return <Loader text={c("loading-films")} loaderColor={loaderColor} />
}
